import { render, staticRenderFns } from "./CreateConfirmationDialog.vue?vue&type=template&id=2faf006c"
import script from "./CreateConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./CreateConfirmationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports